import { FilterOption } from '@shared';

export const PLAYLIST_FILTERS: FilterOption[] = [
    { value: 'block', label: 'Block', icon: 'block' },
    { value: 'feed', label: 'Feeds', icon: 'feeds' },
    { value: 'image', label: 'Image', icon: 'image' },
    { value: 'video', label: 'Video', icon: 'video' },
] as const;

export const CONTENT_SCHEDULE_FILTERS: FilterOption[] = [
    { value: 'active', label: 'Active', icon: 'active' },
    { value: 'in-queue', label: 'In Queue', icon: 'in-queue' },
    { value: 'inactive', label: 'Inactive', icon: 'inactive' },
] as const;

export const PLAYLIST_FILTERS_GROUP: FilterOption[] = [
    {
        label: 'Content Type',
        children: [...PLAYLIST_FILTERS],
    },
    {
        label: 'Content Schedule Status',
        children: [...CONTENT_SCHEDULE_FILTERS],
    },
];
